import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutResponsibilityProspectConversionRateReport extends Layout {
    checkboxIncludeMarketingPlan: Checkbox;
    checkboxPageBreak: Checkbox;
    excludabletextboxCustomerId: ExcludableTextbox;
    excludabletextboxOperationsUser: ExcludableTextbox;
    excludabletextboxSalesManagerId: ExcludableTextbox;
    excludabletextboxSalespersonId: ExcludableTextbox;
    sourceResponsibilityProspectConversionRateReport: DataSource;
    switchInclude: Switch;
    textboxConversionDate: Textbox;
    textboxGroupBy: Textbox;
    textboxHierarchyCode: Textbox;
    textboxHierarchyLevel: Textbox;
    textboxSortBy: Textbox;
    textboxStartDate: Textbox;
}
